import { Paper, Typography, styled } from '@mui/material';
import { fadeIn } from 'theme/animations';

export const Wrap = styled(Paper)<{ index: number }>(({ theme, index }) => ({
	padding: '8px 16px',
	display: 'flex',
	alignItems: 'center',
	gap: '24px',
	width: '100%',
	overflow: 'hidden',
	animation: `${fadeIn} 1s ${index * 0.1}s both`,

	[theme.breakpoints.down('sm')]: {
		padding: '8px',
		gap: '8px',
		flexWrap: 'wrap',
	},
}));

export const GradesWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	flexWrap: 'wrap',
	overflow: 'hidden',
	maxWidth: '100%',
});

export const InfoWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '12px',

	marginLeft: 'auto',

	[theme.breakpoints.down('sm')]: {
		marginLeft: 0,
		width: '100%',
	},
}));

export const DateWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	minWidth: 'fit-content',
	width: '125px',
	flexShrink: 0,
});

export const ProgramName = styled(Typography)(({ theme }) => ({
	maxWidth: '145px',
	textAlign: 'end',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontVariantNumeric: 'tabular-nums',

	[theme.breakpoints.up('sm')]: {
		minWidth: 'fit-content',
	},
}));

export const Date = styled(Typography)({
	width: '125px',
});
